module.exports = __webpack_public_path__ + "static/media/security.ab7cdfca.jpeg";